import { ChannelType, ContactPolicyActionStatus, ContactPolicyChannelType, ContactPolicyVersion } from '../enums';

type ActionStatusesByChannelType = Record<ContactPolicyChannelType, ContactPolicyActionStatus[]>;

const V1ContactPolicyActionStatusesByChannelType: ActionStatusesByChannelType = {
  [ChannelType.EMAIL]: [
    ContactPolicyActionStatus.CLICKED,
    ContactPolicyActionStatus.DISPATCHED,
    ContactPolicyActionStatus.FEEDBACK_SUBMITTED,
    ContactPolicyActionStatus.OPENED,
    ContactPolicyActionStatus.SENT,
  ],
  [ChannelType.LINK]: [
    ContactPolicyActionStatus.CLICKED,
    ContactPolicyActionStatus.CREATED,
    ContactPolicyActionStatus.DISPATCHED,
    ContactPolicyActionStatus.FEEDBACK_SUBMITTED,
  ],
  [ChannelType.MOBILE]: [ContactPolicyActionStatus.FEEDBACK_SUBMITTED],
  [ChannelType.SMS]: [
    ContactPolicyActionStatus.CLICKED,
    ContactPolicyActionStatus.DISPATCHED,
    ContactPolicyActionStatus.FEEDBACK_SUBMITTED,
    ContactPolicyActionStatus.SENT,
  ],
  [ChannelType.WEB_WIDGET]: [ContactPolicyActionStatus.FEEDBACK_SUBMITTED],
  [ChannelType.WHATSAPP]: [
    ContactPolicyActionStatus.CLICKED,
    ContactPolicyActionStatus.DISPATCHED,
    ContactPolicyActionStatus.FEEDBACK_SUBMITTED,
    ContactPolicyActionStatus.SENT,
  ],
  [ChannelType.PUSH_NOTIFICATION]: [
    ContactPolicyActionStatus.CLICKED,
    ContactPolicyActionStatus.DISPATCHED,
    ContactPolicyActionStatus.FEEDBACK_SUBMITTED,
    ContactPolicyActionStatus.SENT,
  ],
  [ChannelType.KIOSK]: [],
  [ChannelType.CATI]: [],
};

const V2ContactPolicyActionStatusesByChannelType: ActionStatusesByChannelType = {
  [ChannelType.EMAIL]: [
    ContactPolicyActionStatus.CLICKED,
    ContactPolicyActionStatus.FEEDBACK_SUBMITTED,
    ContactPolicyActionStatus.OPENED,
    ContactPolicyActionStatus.SENT,
  ],
  [ChannelType.LINK]: [
    ContactPolicyActionStatus.CLICKED,
    ContactPolicyActionStatus.CREATED,
    ContactPolicyActionStatus.FEEDBACK_SUBMITTED,
  ],
  [ChannelType.MOBILE]: [ContactPolicyActionStatus.OPENED, ContactPolicyActionStatus.FEEDBACK_SUBMITTED],
  [ChannelType.SMS]: [
    ContactPolicyActionStatus.CLICKED,
    ContactPolicyActionStatus.FEEDBACK_SUBMITTED,
    ContactPolicyActionStatus.SENT,
  ],
  [ChannelType.WEB_WIDGET]: [ContactPolicyActionStatus.OPENED, ContactPolicyActionStatus.FEEDBACK_SUBMITTED],
  [ChannelType.WHATSAPP]: [
    ContactPolicyActionStatus.CLICKED,
    ContactPolicyActionStatus.FEEDBACK_SUBMITTED,
    ContactPolicyActionStatus.SENT,
  ],
  [ChannelType.PUSH_NOTIFICATION]: [
    ContactPolicyActionStatus.CLICKED,
    ContactPolicyActionStatus.FEEDBACK_SUBMITTED,
    ContactPolicyActionStatus.SENT,
  ],
  [ChannelType.KIOSK]: [],
  [ChannelType.CATI]: [],
};

export const ContactPolicyActionStatusesByVersion: Record<ContactPolicyVersion, ActionStatusesByChannelType> = {
  [ContactPolicyVersion.V1]: V1ContactPolicyActionStatusesByChannelType,
  [ContactPolicyVersion.V2]: V2ContactPolicyActionStatusesByChannelType,
};
